import { render, staticRenderFns } from "./Insights.vue?vue&type=template&id=55034758&scoped=true&"
import script from "./Insights.vue?vue&type=script&setup=true&lang=js&"
export * from "./Insights.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Insights.vue?vue&type=style&index=0&id=55034758&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55034758",
  null
  
)

export default component.exports